import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MapPopup = ({ title, content }) => {
    return (_jsxs("div", { className: "relative w-full rounded-lg bg-white p-4 shadow-md", children: [_jsx("h3", { className: "text-lg font-bold", children: title }), _jsx("hr", { className: "mb-2 h-2" }), _jsx("div", { className: "text-gray-700", children: content })] }));
};
export default MapPopup;
//# sourceMappingURL=MapPopup.js.map